import { isSameDay, isBefore, isAfter, differenceInDays } from 'date-fns';

export function isActiveDate({ targetDate, minDate, maxDate, maxRange, selectedDateList, disabledDateList, checkTime }: {
  targetDate: Date,
  selectedDateList?: Date[],
  disabledDateList?: Date[],
  minDate?: Date,
  maxDate?: Date,
  maxRange?: number,
  // ユーザーがSnowItem購入の際に利用日の選択(SnowItemCalendar.tsx経由)は、手仕舞いの設定で時間まで計算に入れる必要がある一方、
  // アドミンでの料金設定、保険、レッスン、チケット(DatePicker.tsx経由)は時間が関係ないため、分別のフラグを用意。
  checkTime?: boolean
}) {
  // 無効な日
  if (disabledDateList) {
    const isDisabled = disabledDateList.some(date => isSameDay(date, targetDate));
    if (isDisabled) {
      return false;
    }
  }
  // 終了日
  if (maxDate && isAfter(targetDate, maxDate)) {
    return false;
  }
  // 開始日
  if (minDate) {
    // 対象日が開始日かつ時間比較が必要である場合、現在時刻によって判定が変わる
    if (isSameDay(targetDate, minDate) && checkTime) {
      const targetDateWithCurrentTime = new Date();
      targetDateWithCurrentTime.setFullYear(targetDate.getFullYear());
      targetDateWithCurrentTime.setMonth(targetDate.getMonth());
      targetDateWithCurrentTime.setDate(targetDate.getDate());
      if (isAfter(targetDateWithCurrentTime, minDate)) {
        return false;
      }
    } else if (isBefore(targetDate, minDate)) {
      return false;
    }
  }
  // 最大日数
  if (maxRange && selectedDateList[0]) {
    const dateDuration = differenceInDays(targetDate, selectedDateList[0]) + 1;
    if (dateDuration > maxRange) {
      return false;
    }
  }

  return true;
}
